export const TEXT_OPTIONS_HEIGHT = '440px';
